class TreatmentLightbox extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-lightbox-trigger]'));
    this.dialog = this.querySelector('dialog.treatment-hero__lightbox');
    if (!this.dialog || this.triggers.length === 0) return;

    this.image = this.dialog.querySelector('.treatment-hero__lightbox-image');
    this.closeBtn = this.dialog.querySelector('[data-lightbox-close]');
    this.prevBtn = this.dialog.querySelector('[data-lightbox-prev]');
    this.nextBtn = this.dialog.querySelector('[data-lightbox-next]');

    this.images = this.triggers.map((t) => ({
      url: t.dataset.imageUrl,
      alt: t.dataset.imageAlt || ''
    }));
    this.currentIndex = 0;

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const index = parseInt(trigger.dataset.lightboxTrigger, 10);
        this.open(index);
      });
    });

    this.closeBtn?.addEventListener('click', () => this.close());
    this.prevBtn?.addEventListener('click', () => this.show(this.currentIndex - 1));
    this.nextBtn?.addEventListener('click', () => this.show(this.currentIndex + 1));

    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.close();
    });

    this.dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.show(this.currentIndex - 1);
      if (e.key === 'ArrowRight') this.show(this.currentIndex + 1);
    });
  }

  open(index) {
    this.show(index);
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  close() {
    if (typeof this.dialog.close === 'function') {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
    }
  }

  show(index) {
    if (index < 0) index = this.images.length - 1;
    if (index >= this.images.length) index = 0;
    this.currentIndex = index;
    const item = this.images[index];
    if (!item || !this.image) return;
    this.image.src = item.url;
    this.image.alt = item.alt;

    if (this.images.length <= 1) {
      this.prevBtn?.setAttribute('hidden', '');
      this.nextBtn?.setAttribute('hidden', '');
    } else {
      this.prevBtn?.removeAttribute('hidden');
      this.nextBtn?.removeAttribute('hidden');
    }
  }
}

if (!customElements.get('treatment-lightbox')) {
  customElements.define('treatment-lightbox', TreatmentLightbox);
}
